import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableAliveError, RpcObservableAliveKey, RpcObservableAliveRequest, RpcObservableAliveResult
} from './rpc-observable-alive-model';

export class RpcObservableAliveClient
    extends RpcObservableClient<RpcObservableAliveRequest, RpcObservableAliveResult, RpcObservableAliveError>  {

    /**
     * Initializes a new instance of the RpcObservableAliveClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableAliveKey.command, RpcObservableAliveKey.version);
    }

    /**
     * The alive command.
     *
     * @param request the Rpc alive data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableAliveResult> the observable object.
     */
    public alive(request?: RpcObservableAliveRequest, outbound?: RpcOutbound): Observable<RpcObservableAliveResult> {
        if (!request) {
            request = {
                timestamp: Date.now()
            };
        }

        return this.observableCall(request, outbound);
    }

    /**
     * The alive forever command.
     *
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableAliveResult> the observable object.
     */
    public forever(outbound?: RpcOutbound): Observable<RpcObservableAliveResult> {
        const request: RpcObservableAliveRequest = {
            timestamp: Date.now(),
            forever: true
        };
        return this.observableCall(request, outbound);
    }

    /**
     * The reset forever state command.
     *
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableAliveResult> the observable object.
     */
    public reset(outbound?: RpcOutbound): Observable<RpcObservableAliveResult> {
        const request: RpcObservableAliveRequest = {
            timestamp: Date.now(),
            forever: false
        };
        return this.observableCall(request, outbound);
    }
}
